import { getTokenSilently } from '../auth/AuthProvider';

export const getAuthToken = async (): Promise<string | undefined> => getTokenSilently({});
